import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CollapsibleBlockData } from '@app/components/utilities/models/collapsible-model';
import { UntypedFormGroup } from '@angular/forms';
import { ApiService } from '../utilities/services/api.service';
import { LocaleService } from '@app/system/services/locale.service';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { TextAreaModel } from '@app/components/controls/utilities/models/text-area-model';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { DatePickerModel } from '@app/components/controls/utilities/models/date-picker-model';
import { BaseService } from '@app/system/services/base.service';
// import { PopupComponent } from '@app/components/popup/popup.component';
// import { WorkgroupFormsComponent } from '@app/modules/workgroup/workgroup-forms/workgroup-forms.component';
import { ApiService as workgroupApiService } from '../../workgroup/utilities/services/api.service';
// import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DetectDeviceService } from '@app/system/services/detect-device.service';

@Component({
	selector: 'app-knowledge-card-forms',
	templateUrl: './knowledge-card-forms.component.html',
	styleUrls: ['./knowledge-card-forms.component.scss']
})
export class KnowledgeCardFormsComponent implements OnInit {

	popupRef;
	formFields: Array<any> = [];
	loader = false;
	config = { fxFlex: 100 };
	collapsibleData: CollapsibleBlockData = {
		title: ''
	};
	submitDisable = true;
	formObject: any = {};
	currentUser;
	clearTimeout;
	helpTriggered = false;
	action: 'addKnowledgeCard';
	addWorkgroup = false;
	addMembers = false;
	deviceDetails;

	constructor(
		private gfService: GlobalFunctionService,
		private apiService: ApiService,
		private workgroupApiService: workgroupApiService,
		public locale: LocaleService,
		private appInit: AppInitializerService,
		private activatedRouter: ActivatedRoute,
		private globalApiService: GlobalApiService,
		private router: Router,
		// private popup: MatDialog,
		private cdref: ChangeDetectorRef,
		private baseService: BaseService,
		public detectDevice: DetectDeviceService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;
		this.baseService.formView = true;
		if (this.action === 'addKnowledgeCard') {
			if (this.helpTriggered) {
				this.loader = true;
			} else {
				this.popupRef.componentInstance.popupLoader = true;
			}
			const title: TextBoxModel = {
				fieldColumn: 'title',
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: { appearance: 'standard' },
					showLabel: true
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				fieldCaption: this.locale.translate('title'),
				fieldHelpText: this.locale.translate('knowledge_title_help_text'),
				fieldOrder: 1,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('title')
			};
			const description: TextAreaModel = {
				fieldColumn: 'description',
				additionalMetaData: {
					maxChar: 500,
					showLabel: true
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				validationRegex: null,
				fieldCaption: this.locale.translate('instruction'),
				fieldHelpText: null,
				fieldOrder: 2,
				validationMessage: '',
				fieldPlaceholder: this.locale.translate('desc')
			};
			const assignee: AutoCompleteModel = {
				fieldColumn: 'assignee',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					max: 1
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('assign_to'),
				fieldOrder: 3,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_user')
			};
			const completeBy: DatePickerModel = {
				fieldColumn: 'completeByTime',
				additionalMetaData: {
					minDate: 0,
					showLabel: true
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				fieldCaption: this.locale.translate('complete_by'),
				fieldOrder: 4,
				fieldPlaceholder: this.locale.translate('complete_by')
			};

			// const headers: any = {};
			// this.workgroupApiService.getList(headers).subscribe(
			// 	(response) => {
			// 		if (response && response.hasOwnProperty('records')) {
			// 			let addMembers = true;
			// 			for (const data of response.records) {
			// 				if (data.memberCount > 0) {
			// 					addMembers = false;
			// 				}
			// 			}
			// 			this.addMembers = addMembers;
			// 		} else {
			// 			this.addWorkgroup = true;
			// 		}
			// 	},
			// 	(error) => {
			// 		this.gfService.errorHandler(error, {
			// 			snackBar: {
			// 				position: 'before'
			// 			}
			// 		});
			// 	},
			// 	() => {
			// 		this.formFields = [title, description, assignee, completeBy];
			// 		if (this.helpTriggered) {
			// 			this.loader = false;
			// 		} else {
			// 			this.popupRef.componentInstance.popupLoader = false;
			// 		}
			// 		this.submitDisable = false;

			// 	}
			// );
			this.formFields = [title, description, assignee, completeBy];
			if (this.helpTriggered) {
				this.loader = false;
			} else {
				this.popupRef.componentInstance.popupLoader = false;
			}
			this.submitDisable = false;

		}
	}

	formObjectReader(record) {
		let subscribe;
		this.formObject = record;
		const form: UntypedFormGroup = this.formObject.form;
		const userField = record.fields.find((items) => items.fieldColumn === 'assignee');
		form.controls.assignee.valueChanges.subscribe((controlResp) => {
			if (navigator.onLine) {
				if (subscribe && !subscribe['closed']) {
					subscribe.unsubscribe();
				}
				if (this.clearTimeout) {
					clearTimeout(this.clearTimeout);
				}
				this.clearTimeout = setTimeout(() => {
					if (controlResp && typeof controlResp === 'string') {
						// const userFilter: any = { $and: [] };
						// const splitVal = controlResp.toLowerCase().split(' ');
						// for (const value of splitVal) {
						//   userFilter.$and.push({
						//     $or: {
						//       '$accountDetail.firstName$': { $substring: value },
						//       '$accountDetail.lastName$': { $substring: value }
						//     }
						//   });
						// }
						const apiData = {
							searchString: controlResp
						};
						const header: any = {};
						subscribe = this.globalApiService.getWorkGroupUsers(apiData, header).subscribe(
							(response) => {
								if (response && response.records.length) {
									userField.options = response.records.map((data) => {
										return {
											key: data,
											value: `${data.firstName}${data.lastName
												? ' ' + data.lastName
												: ''}`,
											prefix: {
												type: 'image',
												value: data.profilePicURL
											},
											shortInfo: this.baseService.getUserShortInfo(data)
											// shortInfo: [
											// 	{
											// 		value: 'Company'
											// 	},
											// 	{
											// 		value: 'Department'
											// 	},
											// 	{
											// 		value: 'Location'
											// 	}
											// ]
										};
									});
									this.cdref.detectChanges();
								} else {
									userField.options = [];
								}
							},
							(error) => {
								this.gfService.errorHandler(error, {
									snackBar: {
										position: 'before'
									}
								});
								userField.options = [];
							}
						);
					} else {
						userField.options = [];
					}
				}, this.appInit.configuration.searchDelay);
			}
		});
	}

	update() {
		if (navigator.onLine) {
			if (this.action === 'addKnowledgeCard') {
				this.addKnowledgeCard();
			}
		}
	}

	workgroupForm(action: string, additionalMetaData: any) {
		if (navigator.onLine) {
			this.popupRef.close();
			const queryParams = {
				tab: 'my_workgroups'
			};
			this.gfService.routeNavigation('workgroup', queryParams);
		}
		// const dialogRef = this.popup.open(PopupComponent, {
		// 	panelClass: ['custom-panel'],
		// 	data: {
		// 		action: 'dynamic',
		// 		popup: true,
		// 		component: WorkgroupFormsComponent,
		// 		componentData: [
		// 			{
		// 				variableName: 'action',
		// 				value: action
		// 			}
		// 		],
		// 		triggerEl: additionalMetaData.actionElement
		// 	},
		// 	disableClose: true,
		// 	maxWidth: '860px'
		// });
		// dialogRef.afterClosed().subscribe(async (result) => {
		// 	if (result && typeof result === 'object') {
		// 		if (action === 'createWorkgroup') {

		// 		}
		// 	}
		// });


	}

	addKnowledgeCard() {
		if (this.formObject && this.formObject.form) {
			this.gfService.alertClear('add-alert');
			this.submitDisable = true;
			if (this.formObject.form.valid) {
				if (this.helpTriggered) {
					this.loader = true;
				} else {
					this.popupRef.componentInstance.popupLoader = true;
				}
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				formValue.assignee = formValue.assignee.filter(items => items.isAdd && !items.isDelete);
				// formValue.type = 2;
				formValue.taskGroup = 1;
				// formValue.resourceTypeID = 1;
				formValue.languageCode = 'en';
				formValue.authors = [{
					id: this.currentUser.userID
				}];
				const apiValue = this.gfService.JSONMerge(formValue, { assignee: formValue.assignee[0].key.userID });
				apiValue.notificationType = 1;

				if (this.deviceDetails.browserName === 'Safari') {
					apiValue.notificationType = 2;
				}
				this.apiService
					.add(apiValue)
					.subscribe(
						(response) => {
							if (response) {
								this.baseService.logUserActivity('assignknowledgecard', 'engagement', ['']);
								this.popupRef.close(this.gfService.JSONMerge(formValue, response.recordID));
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('knowledge_card_assigned'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'PERMISSION_DENIED') {
								error.error = this.locale.translate('you_do_not_have_permission_to_add_knowledge_card');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'add-alert'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						if (this.helpTriggered) {
							this.loader = false;
						} else {
							this.popupRef.componentInstance.popupLoader = false;
						}
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}
}
